import { ColumnType, TransferUserInfoType } from '../types';
import { ACCOUNT_USER_STATUS_TEXT } from '../../../../../../../constants/service/app/accountUserConstants';

export const columns = (data: TransferUserInfoType): ColumnType[] => [
  {
    title: '회원번호',
    value: data.id,
  },
  {
    title: '계정 상태',
    value: ACCOUNT_USER_STATUS_TEXT[data.status as number] || '-',
  },
  {
    title: '이름',
    value: data.name,
  },
  {
    title: '유저 계정',
    value: data.account,
  },
  {
    title: '로그인 타입',
    value: data.loginType,
  },
  {
    title: '핸드폰',
    value: data.cellPhone,
  },
  {
    title: '가입일자',
    value: data.createDate,
  },
];
